import { Injectable } from "@angular/core";
import { Observable, combineLatest } from "rxjs";
import { map } from "rxjs/operators";

import { DeviceService } from "./device.service";
import { ScrollHideService } from "./scroll-hide.service";

@Injectable({
  providedIn: "root"
})
export class MobileFooterService {
  private readonly _footerHeight = 60; // 3.75rem = 60px

  constructor(
    private readonly deviceService: DeviceService,
    private readonly scrollHideService: ScrollHideService
  ) {}

  /**
   * Get observable that emits true when footer is visible
   */
  isFooterVisible$(): Observable<boolean> {
    return combineLatest([this.deviceService.isPwaMode$, this.scrollHideService.getFooterVisibility()]).pipe(
      map(([isPwa, isHidden]) => {
        // Footer is visible if we're in PWA mode AND it's not hidden by scroll
        return isPwa && !isHidden;
      })
    );
  }

  /**
   * Get the footer height in pixels
   */
  getFooterHeight(): number {
    return this._footerHeight;
  }

  /**
   * Get observable that emits the bottom offset needed for floating elements
   * Returns 0 when footer is hidden, footer height when visible
   */
  getFloatingElementOffset$(): Observable<number> {
    return this.isFooterVisible$().pipe(map(isVisible => (isVisible ? this._footerHeight : 0)));
  }
}
